import { Injectable } from "@nestjs/common";
import { RmCountPriceListDTO } from "./rm-count-pricelist.dto";
import { RmRates } from "../rm-rates-entity";
import { CompanyCategoryEnum } from "@gtpl/shared-models/raw-material-procurement";
@Injectable()
export class RmCountPriceListAdapter{
    public convertDtoToEntity(RmCountPriceListDTO:RmCountPriceListDTO, isUpdate: boolean = false):RmRates{
        const rmCountPriceList = new RmRates();
        rmCountPriceList.rmratesId = RmCountPriceListDTO.rmratesId;
        // rmCountPriceList.minValue = RmCountPriceListDTO.minValue;
        // rmCountPriceList.maxValue = RmCountPriceListDTO.maxValue;
        rmCountPriceList.price = RmCountPriceListDTO.price;
        rmCountPriceList.count = RmCountPriceListDTO.count;
        rmCountPriceList.company = RmCountPriceListDTO.company
        rmCountPriceList.category = RmCountPriceListDTO.company ==='BMR'? CompanyCategoryEnum.OWN:CompanyCategoryEnum.OTHER
        rmCountPriceList.type = RmCountPriceListDTO.type
        rmCountPriceList.isActive=RmCountPriceListDTO.isActive==undefined?true:RmCountPriceListDTO.isActive;
        // rmCountPriceList.midPrice = RmCountPriceListDTO.midPrice
        // rmCountPriceList.minPrice = RmCountPriceListDTO.minPrice
        // rmCountPriceList.highPrice =RmCountPriceListDTO.highPrice
        rmCountPriceList.effectiveFromDate = RmCountPriceListDTO.effectiveFromDate
        rmCountPriceList.effectiveToDate = RmCountPriceListDTO.effectiveToDate
        if (isUpdate) {
            rmCountPriceList.updatedUser = RmCountPriceListDTO.updatedUser;
        } else {
            rmCountPriceList.isActive = true;
            rmCountPriceList.createdUser =RmCountPriceListDTO.createdUser;
        }
        return rmCountPriceList;
        }
    public convertEntityToDto(rmCountPriceListObject:RmRates):RmCountPriceListDTO{
        const rmCountPriceListDTO = new RmCountPriceListDTO;
        rmCountPriceListDTO.rmratesId = rmCountPriceListObject.rmratesId;
        // rmCountPriceListDTO.minValue = rmCountPriceListObject.minValue;
        // rmCountPriceListDTO.maxValue = rmCountPriceListObject.maxValue;
        rmCountPriceListDTO.count = rmCountPriceListObject.count;
        rmCountPriceListDTO.price = rmCountPriceListObject.price;
        rmCountPriceListDTO.isActive=rmCountPriceListObject.isActive;
        rmCountPriceListDTO.createdUser=rmCountPriceListObject.createdUser;
        rmCountPriceListDTO.updatedUser=rmCountPriceListObject.updatedUser;
        rmCountPriceListDTO.createdAt=rmCountPriceListObject.createdAt;
        rmCountPriceListDTO.updatedAt=rmCountPriceListObject.updatedAt;
        rmCountPriceListDTO.versionFlag=rmCountPriceListObject.versionFlag;
        rmCountPriceListDTO.company = rmCountPriceListObject.company
        // rmCountPriceListDTO.midPrice = rmCountPriceListObject.midPrice
        // rmCountPriceListDTO.minPrice = rmCountPriceListObject.minPrice
        // rmCountPriceListDTO.highPrice = rmCountPriceListObject.highPrice
        rmCountPriceListDTO.type = rmCountPriceListObject.type
        rmCountPriceListDTO.effectiveFromDate = rmCountPriceListDTO.effectiveFromDate
        rmCountPriceListDTO.effectiveToDate = rmCountPriceListDTO.effectiveToDate
       return rmCountPriceListDTO;
    }
}